<template>
    <div>
        <MainModal
            :show-modal="showModal" :close-btn="false" size="sm" :footer="false"
            @close="$emit('close')"
        >
            <template #body>
                <div class="mb--15 p-4" :class="{ 'disabled': disabled }">
                    <div class="flex align-items-center justify-content-center success__img__wrap p--20">                        
                        <svg
                            xmlns="http://www.w3.org/2000/svg" width="80px" height="80px" viewBox="0 0 1024 1024"
                            class="icon" version="1.1"
                        ><path d="M905.92 237.76a32 32 0 0 0-52.48 36.48A416 416 0 1 1 96 512a418.56 418.56 0 0 1 297.28-398.72 32 32 0 1 0-18.24-61.44A480 480 0 1 0 992 512a477.12 477.12 0 0 0-86.08-274.24z" fill="#a9afc2" /><path
                            d="M630.72 113.28A413.76 413.76 0 0 1 768 185.28a32 32 0 0 0 39.68-50.24 476.8 476.8 0 0 0-160-83.2 32 32 0 0 0-18.24 61.44zM489.28 86.72a36.8 36.8 0 0 0 10.56 6.72 30.08 30.08 0 0 0 24.32 0 37.12 37.12 0 0 0 10.56-6.72A32 32 0 0 0 544 64a33.6 33.6 0 0 0-9.28-22.72A32 32 0 0 0 505.6 32a20.8 20.8 0 0 0-5.76 1.92 23.68 23.68 0 0 0-5.76 2.88l-4.8 3.84a32 32 0 0 0-6.72 10.56A32 32 0 0 0 480 64a32 32 0 0 0 2.56 12.16 37.12 37.12 0 0 0 6.72 10.56zM230.08 467.84a36.48 36.48 0 0 0 0 51.84L413.12 704a36.48 36.48 0 0 0 51.84 0l328.96-330.56A36.48 36.48 0 0 0 742.08 320l-303.36 303.36-156.8-155.52a36.8 36.8 0 0 0-51.84 0z" fill="#a9afc2" style="
"
                        /></svg>
                    </div>

                    <template v-if="customText">
                        <slot name="customText" />
                    </template>

                    <template v-else>
                        <h2 class="text-gray-700 text-center text--semi--bold text--lg">
                            {{ title }}
                        </h2>
                        <p class="text-center text-gray-600 mt--5 text--sm">
                            {{ desc }}
                        </p>
                    </template>

                    <template v-if="btnCta">
                        <div class="mt--30 w-100 flex justify-content-center align-items-center">
                            <BaseButton
                                :label="btnCta" 
                                :loading="isBtnDisabled"
                                @click="$emit('close')"
                            />
                        </div>
                    </template>
                </div>
            </template>
        </MainModal>
    </div>
</template>

<script>
import BaseButton from "../buttons/BaseButton.vue";
import MainModal from "./MainModal.vue";

export default {
    name: "ProgressSuccess",

    components: {
        MainModal,
        BaseButton,
    },

    // 8f8f8f 279ca97d 279ca9a6

    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "",
        },
        desc: {
            type: String,
            default: "",
        },
        customText: {
            type: Boolean,
            default: false,
        },
        isBtnDisabled: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        btnCta: {
            type: String,
            default: "",
        },
    },
};
</script>

<style lang="scss" scoped>

.success {
    &__img {
        &__wrap {
            position: relative;
            margin-bottom: 2rem;
        }

        &__stacked {
            position: absolute;
            bottom: 29%;
            right: 34%;
            bottom: 5%;
        }
    }
}
    .success__modal__body {
        padding: 15px 15px 5px !important
    }
</style>